export const initialState = {
  invoice: {
    name: '',
    address: '',
    email: '',
    phone: '',
    website: '',
    bankName: '',
    bankAccount: '',
    clientName: '',
    clientAddress: '',
    invoiceNumber: '',
    invoiceDate: '',
    dueDate: '',
    notes: '',
    description: '',
    quantity: 0,
    price: 0,
    amount: 0,
    list: [],
    totalAmount: 0,
    selectedSymbol: 'USDT',
  },
};
